import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

const getHost = function () {
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const username = pathParts[1] || ''; 

  return username;
};

export const AuthProvider = ({ children }) => {
  const [username, setUsername] = useState(getHost);

  const [auth, setAuth] = useState(() => {
    const storedAuth = localStorage.getItem("auth");
    return storedAuth ? JSON.parse(storedAuth) : {};
  });

  useEffect(() => {
    localStorage.setItem("auth", JSON.stringify(auth));
  }, [auth]);

  return (
    <AuthContext.Provider value={{ auth, setAuth, username, setUsername }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
